const contactsIcons = [
  {
    name: "email",
    icon: "fa-solid fa-envelope",
  },
  {
    name: "facebook",
    icon: "fa-brands fa-facebook",
  },
  {
    name: "instagram",
    icon: "fa-brands fa-square-instagram",
  },
  {
    name: "twitter",
    icon: "fa-brands fa-square-x-twitter",
  },
  {
    name: "linkedin",
    icon: "fa-brands fa-linkedin",
  },
  {
    name: "youtube",
    icon: "fa-brands fa-youtube",
  },
];

export default contactsIcons;
